import Vue from 'vue'
import UUID from 'vue-uuid';
import VueCookies from 'vue-cookies';
import device from "vue-device-detector";
import VueLazyload from 'vue-lazyload';

import App from './App.vue';
import router from './router';
import titleMixin from './mixins/titleMixin';
import { i18n } from './plugins/i18n.js';
import { initConsentMode } from './helper/consent';
import { helpers } from './helper/portal_config';

import './assets/css/global.css';
import './assets/css/fonts.css';

Vue.config.productionTip = false;

Vue.mixin(titleMixin);
Vue.use(UUID);
Vue.use(VueCookies);
Vue.use(device);
Vue.use(VueLazyload);

// Google Consent Mode v2: set default consent before any tags fire.
// Consent is required only for Google flows. If the landing runs on the default affiliate tracking,
// we disable the consent popup and do not initialize consent mode.
if (helpers.tracking_aff !== 'AFFd3fAu1t0') {
  initConsentMode();
}

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')